import { render, staticRenderFns } from "./columnsManager.vue?vue&type=template&id=ab5b2fba&scoped=true&lang=html&"
import script from "./columnsManager.vue?vue&type=script&lang=js&"
export * from "./columnsManager.vue?vue&type=script&lang=js&"
import style0 from "./columnsManager.vue?vue&type=style&index=0&id=ab5b2fba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab5b2fba",
  null
  
)

export default component.exports